import { useTranslation } from "react-i18next";

/** Minimal full-height placeholder shown while the auth context hydrates. */
export function AuthLoading() {
  const { t } = useTranslation();
  return (
    <div
      style={{
        minHeight: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "var(--text-faint)",
      }}
    >
      {t("common.loading")}
    </div>
  );
}
